import { useEffect, useRef, useState } from "react";
import "./s62-photos.css";

export type S62TastingPhoto = { url: string; label: string };

/** URLs must come from the existing authorized media endpoint. */
export function S62TastingPhotoViewer({ photos }: { photos: readonly S62TastingPhoto[] }) {
  const [active, setActive] = useState<S62TastingPhoto | null>(null);
  const dialog = useRef<HTMLDialogElement>(null);
  const opener = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (active && dialog.current && !dialog.current.open) dialog.current.showModal();
  }, [active]);

  if (!photos.length) return null;
  return <section className="s62-tasting-photos" aria-label="Photos de la dégustation">
    <div className="s62-photo-thumbnails">
      {photos.map((photo, index) => <button type="button" key={`${index}:${photo.url}`}
        className="s62-photo-thumbnail" aria-label={`Ouvrir ${photo.label}`}
        onClick={event => { opener.current = event.currentTarget; setActive(photo); }}>
        <img src={photo.url} alt={photo.label}/><span>{photo.label}</span>
      </button>)}
    </div>
    <dialog ref={dialog} className="s62-photo-dialog" aria-label={active?.label ?? "Photo de la dégustation"}
      onKeyDown={event => {
        if (event.key === "Tab") {
          event.preventDefault();
          dialog.current?.querySelector<HTMLButtonElement>("button")?.focus();
        }
      }}
      onClick={event => { if (event.target === event.currentTarget) dialog.current?.close(); }}
      onClose={() => { setActive(null); opener.current?.focus({ preventScroll: true }); }}>
      <div className="s62-photo-dialog-content">
        <button type="button" className="secondary" autoFocus onClick={() => dialog.current?.close()}>Fermer la photo</button>
        {active && <img src={active.url} alt={active.label}/>}
      </div>
    </dialog>
  </section>;
}
